import { useCallback, useEffect, useRef, useState } from 'react';

export const useManualInput = () => {
    const ref = useRef(null);
    const [manual, setManual] = useState(false);

    const activateManual = useCallback(() => {
        setManual(true);
    }, []);

    useEffect(() => {
        if (manual && ref && ref.current) {
            ref.current.focus();
        }
    }, [manual]);

    return { ref, manual, setManual, activateManual };
};
